import { useGetGroupMeetingsInfinite } from '@repo/api/group/useGetGroupMeetings';
import { useInfiniteQueryResult } from '@repo/hooks/useInfiniteQueryResult';
import { startOfDay } from 'date-fns';

import MeetingsListContent from '@/components/features/calendar/MeetingsListContent';

import MeetingsList from '../calendar/MeetingsList';
import GroupElementHeader from './layout/GroupElementHeader';

/**
 * Props for the GroupMeetings component.
 * @property {number} groupId - The group ID for which meetings are displayed.
 */
interface GroupMeetingsProps {
  groupId: number;
}

export default function GroupMeetings(groupMeetingsProps: GroupMeetingsProps) {
  const { groupId } = groupMeetingsProps;

  const query = useGetGroupMeetingsInfinite({
    id: groupId,
    after: startOfDay(new Date()).toISOString(),
    sortOrder: 'ASC',
    pageSize: 2,
  });

  const { data: meetings = [] } = useInfiniteQueryResult(query.data);

  return (
    <div className={'border-border-primary bg-background flex shrink-0 flex-col rounded-2xl border'}>
      <GroupElementHeader label={'Nadchodzące spotkania'} />

      <MeetingsList meetings={meetings} query={query} disableInfiniteScroll>
        <MeetingsListContent />
      </MeetingsList>
    </div>
  );
}
